<!-- nlc-style Page Header -->
<div 
  class="nlc-page-header nlc-fade-in"
  [class.gradient-variant]="variant === 'gradient'"
  [class.light-variant]="variant === 'light'"
  >
  
  <div class="nlc-container header-content"  style="display: flex; flex-direction: column; justify-content: center; align-items: center; align-self: center;">
    <!-- Back Button -->
    <button 
      *ngIf="showBackButton"
      type="button" 
      class="nlc-back-button" 
      (click)="goBack()" 
      aria-label="Zurück">
      <mat-icon>arrow_back</mat-icon>
    </button>
    
    <div class="header-container">
      <!-- Icon -->
      <div *ngIf="icon" class="header-icon">
        <mat-icon>{{ icon }}</mat-icon>
      </div>
      <!-- Title and Subtitle -->
      <div class="header-text">
        <h1 class="nlc-heading-1" [class.nlc-heading-2]="showBackButton">{{ title }}</h1>
        <p *ngIf="subtitle" class="nlc-body-secondary">{{ subtitle }}</p>
      </div>
    </div>

    <!-- Action Buttons -->
    <div *ngIf="actions.length > 0" class="header-actions">
      <button 
        *ngFor="let action of actions"
        class="nlc-button nlc-button-primary nlc-button-small"
        style="padding-bottom: 15px;"
        [class.nlc-button-primary]="action.variant === 'primary' || !action.variant"
        [class.nlc-button-secondary]="action.variant === 'secondary'"
        [class.nlc-button-success]="action.variant === 'success'"
        [class.nlc-button-error]="action.variant === 'error'"
        (click)="handleAction(action)">
        <mat-icon *ngIf="action.icon" style="padding-top: 8px;">{{ action.icon }}</mat-icon>
        {{ action.label }}
      </button>
    </div>
  </div>
  <div style="border: 1px;"></div>
</div>
